﻿import apiService from './api';
import type { ApiResponse } from '../types';

/**
 * The account's language, kept on the server so it follows the person to
 * every device (HHNodeServer `users.preferred_language`, routes/users.js).
 */
const languageService = {
  async get(): Promise<ApiResponse<{ language: string | null }>> {
    return apiService.get('/users/me/language');
  },
  async set(language: string | null): Promise<ApiResponse<{ language: string | null }>> {
    return apiService.put('/users/me/language', { language });
  },
  /** Emails support@ asking for a language. The server throttles repeats. */
  async request(language: string, note: string): Promise<ApiResponse<{ sent: boolean }>> {
    return apiService.post('/users/me/translation-request', { language, note: note || undefined });
  },
};

export default languageService;
